import { useState, useEffect } from 'react';
import { A01, A01Input, A01Output } from 'api/U002';
import { FetchError } from 'api/API';

type GetAuditionRequest = A01Input;
export type GetAuditionResponse = Omit<
  A01Output,
  'start_dtm' | 'end_dtm' | 'birth' | 'specific_use_consent'
> & {
  start_dtm: Date;
  end_dtm: Date;
  user_detail_flg: string;
  birth: Date;
  phone_number: string;
  specific_use_consent: string;
  privacy_policy_consent: string;
  audition_terms_consent: string;
  group_ap: string;
};
export function useGetAudition(
  param: GetAuditionRequest
): [GetAuditionResponse | null, boolean, Error | null] {
  const [loading, setLoading] = useState<boolean>(true);
  const [audition, setAudition] = useState<GetAuditionResponse | null>(null);
  const [err, setError] = useState<Error | null>(null);

  const FetchAudition = async (param: A01Input, cancellation: AbortSignal) => {
    const json = await A01(param, cancellation);
    return json;
  };

  useEffect(() => {
    console.log('useGetAudition:useEffect', param);
    const controller = new AbortController();
    const signal = controller.signal;
    async function fetch() {
      if (!param.audition_id) return;
      try {
        setLoading(true);
        setError(null);
        const audition = await FetchAudition({ ...param }, signal);
        const parseAudition = {
          ...audition,
          start_dtm: new Date(audition.start_dtm),
          end_dtm: new Date(audition.end_dtm),
          now_dtm: new Date(audition.now_dtm),
          birth: new Date(audition.birth),
          specific_use_consent: audition.specific_use_consent,
        };
        setAudition(parseAudition);
      } catch (err) {
        if (err instanceof DOMException && err.message === 'signal is aborted without reason')
          return;
        if (err instanceof FetchError) {
          const errorData = await err.response.json();
          const flooredError = new Error(errorData.message || `HTTP ERROR: ${err.message}`);
          setError(flooredError);
          console.log({ flooredError });
          return flooredError;
        }
        if (err instanceof Error) {
          setError(err);
        } else {
          setError(new Error(`unknown error. ${err}`));
        }
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      controller.abort();
    };
  }, [param.audition_id, param.lang]);

  return [audition, loading, err];
}
